import { lazy } from "react";
import PropTypes from 'prop-types';

/**
 * @module helpers/lazyWithRetry
 * @category Helpers
 * @description Um helper que fornece uma função para executar operações de forma preguiçosa com tentativas de repetição.
 * @param {Function} fn - A função a ser executada.
 * @param {number} retries - O número de tentativas de repetição.
 * @returns {Promise} Uma promessa que resolve o resultado da função executada.
 */
const lazyWithRetry = (componentImport) =>
  lazy(async () => {
    const pageHasAlreadyBeenForceRefreshed = JSON.parse(
      window.localStorage.getItem("page-has-been-force-refreshed") || "false"
    );

    try {
      const component = await componentImport();

      window.localStorage.setItem("page-has-been-force-refreshed", "false");

      return component;
    } catch (error) {
      if (!pageHasAlreadyBeenForceRefreshed) {
        // Assuming that the user is not on the latest version of the application.
        // Let's refresh the page immediately.
        window.localStorage.setItem("page-has-been-force-refreshed", "true");
        return window.location.reload();
      }

      // The page has already been reloaded
      // Assuming that user is already using the latest version of the application.
      // Let's let the application crash and raise the error.
      throw error;
    }
  });

lazyWithRetry.propTypes = {
  componentImport: PropTypes.func.isRequired,
};

export default lazyWithRetry;
